export function initMember() {
    initGroupSelect()
}

function initGroupSelect() {
    const select = document.getElementById('group-select')
    if (!select) return

    select.addEventListener('change', () => select.parentElement.submit())
}